import React from 'react'
import { View, Image, useWindowDimensions, Linking, ImageBackground, Pressable } from 'react-native'
import { Text, Button } from '@ui-kitten/components'
import tailwind from 'tailwind-rn'
import { useNavigation, DrawerActions } from '@react-navigation/native'
import { useMediaQuery } from 'react-responsive'
import Icon from 'react-native-vector-icons/FontAwesome5'

import Colors from '../constants/Colors'

const FooterMenu = () => {

  const isLargeScreen = useMediaQuery({minDeviceWidth: 440})
  const windowWidth = isLargeScreen ? 800 : useWindowDimensions().width
  const windowHeight = useWindowDimensions().height
  const navigation = useNavigation()

  const _goZap = () => {
    Linking.openURL('https://api.whatsapp.com/send?phone=557131864000')
  }

  const _goSebrae = () => {
    Linking.openURL('https://www.sebrae.com.br/sites/PortalSebrae/ufs/ba?codUf=5')
  }

  const _goSenac = () => {
    Linking.openURL('https://www.ba.senac.br')
  }

  if (isLargeScreen) {
    return (
      <View style={{backgroundColor: Colors.laranja_forte, height: 100}}>
        <View style={[tailwind('mx-5 mt-4 flex-row self-center'), {width: windowWidth}]}>
          <Text style={tailwind('mx-5 mt-4 self-center text-xs')}>Copyright 2021 © </Text>
          <Image source={require('../assets/images/logos.svg')} style={{width: windowWidth/2-100, height: 50, tintColor: Colors.cinza}} resizeMode="contain" />
        </View>
    </View>
    )
  } else {
    return (
      <ImageBackground source={require('../assets/images/bg_menu.svg')} style={{width: windowWidth, height: 100, bottom: 0, position: 'absolute', zIndex:10}} resizeMode="cover" >
      <View style={tailwind('items-center flex-row justify-between mx-20 mt-10 pt-3')}>
        <Icon name="bars" color="#8a509e" size={24} onPress={() => navigation.dispatch(DrawerActions.openDrawer())} />
      </View>
    </ImageBackground>
    )
  }
  }

export default FooterMenu
